export const ROUTES = {
  QUERYPARAMS: "/:instanceid?",
  HOME: "/",
  DASHBOARD: "/dashboard",
  ACCOUNT: "/account",
  APPS: "/apps",
  HELPPLUSSUPPORT: "/helpplussupport",
  QUERYANDISSUES: "/queryandissues",
  SECURITY: "/security",
  // Main navigation
  INBOX: "/inbox",
  ANALYTICS: "/analytics",
  SURVEYS: "/surveys",
  SURVEY_CREATE: "/surveys/new",
  SURVEY_DETAIL: "/surveys/:id",
  SURVEY_EDIT: "/surveys/:id/edit",
  SURVEY_PREVIEW: "/surveys/:id/preview",
  SURVEY_RESULTS: "/surveys/results",
  SURVEY_RESULTS_DETAIL: "/surveys/results/:id",
  SURVEY_REQUESTS: "/surveys/requests",
  SURVEY_TEMPLATES: "/surveys/templates",
  PUBLIC_SURVEY: "/survey/:instanceId/:token",

  // Settings routes - Unique/Remaining
  PLATFORM: "/settings/session",

  // Auth & system routes
  ERRORPAGE: "/errorpage",
  CALLBACK: "/auth/callback",
  SKYPOINTLOGIN: "/skypointlogin",
  SKYPOINTSIGNUP: "/skypointsignup",

  // Merged Routes (New /clean paths)
  VIEWINSTANCES: "/instances",
  VIEWINSTANCEDETAILS: "/instanceDetails",
  VIEWINSTANCEHISTORY: "/instanceHistory",
  VIEWINSTANCEBACKUP: "/instanceBackup",
  TENANTSETIINGS: "/tenants",
  CREATETENANT: "/createTenant",
  LOCATIONS: "/locations",
  LOCATION_DETAIL: "/locations/:locationId",
  OPERATORS: "/operators",
  OPERATOR_DETAIL: "/operators/:operatorId",
  OWNERS: "/owners",
  LOGS: "/logs",
  USERS: "/users",
  USER_SETUP: "/user-setup",
  ROLES: "/roles",
  GENERAL_SETTINGS: "/general-settings",
  ASA: "/asa",
  ASA_DETAIL: "/asa/:asaId",
  ASA_LOCATIONS: "/asa/:asaId/locations",
  CHANNELS: "/channels",
  CALL_LOGS: "/call-logs",
  CALL_ANALYTICS: "/call-analytics",
  UTM_ANALYTICS: "/utm-analytics",
  CAMPAIGN_ATTRIBUTION: "/campaign-attribution",
  AD_CAMPAIGNS: "/ad-campaigns",
  AD_CAMPAIGN_DETAIL: "/ad-campaigns/:id",
  DRIP_CAMPAIGNS: "/drip-campaigns",
  DRIP_CAMPAIGN_DETAIL: "/drip-campaigns/:id",
  DRIP_CAMPAIGN_EDITOR: "/drip-campaigns/:id/edit",
  MODAL_ANALYTICS: "/asa-modal-analytics",
  MODAL_CONFIGS: "/asa-modal-configs",
  AUTO_TRIGGERS: "/asa-auto-triggers",
  WIDGET_PLACEMENTS: "/asa-widget-placements",
  EMBED_SCRIPT: "/asa-embed-script",
  TRAINING: "/training",
  LEADS: "/leads",
  LEAD_DETAIL: "/leads/:leadId",
  CRM_LANDING: "/crm",
  CRM_OVERVIEW: "/crm/overview",
  CRM_TODAY: "/crm/today",
  CRM_SKYAGENT: "/crm/skyagent",
  // skyBrain (Inc-3) — what the agent has been told to remember. A child path of
  // skyagent, not a Settings page: it is the agent's memory, and the people who
  // need to correct it are the counselors using it, not administrators.
  CRM_SKYBRAIN: "/crm/skyagent/brain",
  // Skills (V191) — the written playbooks a person gives the agent. A sibling of
  // skyBrain under skyagent for the same reason: it belongs to the people using
  // the agent, not to administrators.
  CRM_AGENT_SKILLS: "/crm/skyagent/skills",
  // Connectors — the remote MCP servers a manager registers for this customer.
  // A child of skyagent like the two above, and reached mainly from the
  // composer's "+" menu rather than from the sidebar: registering a server is a
  // rare managerial act, connecting your own account is the everyday one.
  CRM_MCP_CONNECTORS: "/crm/skyagent/connectors",
  // Drafts (V192) — things skyAgent wrote that nobody has sent. A child of
  // skyagent because that is where they are written and where they are used.
  CRM_AGENT_DRAFTS: "/crm/skyagent/drafts",
  CRM_FORECAST_FALLOUT: "/crm/forecast/fallout",
  CRM_DAY_PLANNER: "/crm/day-planner",
  CRM_ACTIVITIES: "/crm/activities",
  CRM_PERSONS: "/crm/persons",
  CRM_PERSON_DETAIL: "/crm/persons/:personId",
  CRM_RESIDENTS: "/crm/residents",
  CRM_RESIDENT_DETAIL: "/crm/residents/:residentId",
  CRM_REFERRERS: "/crm/referrers",
  CRM_REFERRER_DETAIL: "/crm/referrers/:referrerId",
  // REF-9b-1 — person-first referrer surfaces (parallel to the org list during
  // the strangler cutover; the org routes above stay live until 7b).
  CRM_REFERRER_PERSONS: "/crm/referrer-persons",
  CRM_ORGANIZATIONS: "/crm/organizations",
  CRM_ORGANIZATION_DETAIL: "/crm/organizations/:id",
  CRM_REFERRER_PERSON_DETAIL: "/crm/referrer-persons/:id",
  CRM_ADMISSIONS: "/crm/admissions",
  CRM_OCCUPANCY: "/crm/occupancy",
  CRM_OCCUPANCY_BOARD: "/crm/occupancy/board",
  CRM_OCCUPANCY_UNITS: "/crm/occupancy/units",
  CRM_OCCUPANCY_WAITLIST: "/crm/occupancy/waitlist",
  CRM_OCCUPANCY_TRANSITIONS: "/crm/occupancy/transitions",
  CRM_YARDI_RESOLUTION: "/crm/occupancy/yardi-resolution",
  CRM_OCCUPANCY_REPORT: "/crm/occupancy/report",
  CRM_REPORTS: "/crm/reports",
  // G13 — the report builder. STATIC segments outrank the ":reportId" detail
  // route in React Router's ranking, so /crm/reports/builder resolves to the
  // builder and never to a report called "builder". (Do NOT append QUERYPARAMS
  // to anything under /crm/reports — see the hazard note in appRoutes.ts.)
  CRM_REPORT_BUILDER: "/crm/reports/builder",
  CRM_REPORT_BUILDER_EDIT: "/crm/reports/builder/:reportId",
  // PLC W16 Inc-2 — every schedule the caller can see, in one place. A STATIC
  // segment, so it outranks ":reportId" exactly as "builder" does (no
  // descriptor id is "schedules"; no QUERYPARAMS, same hazard note).
  CRM_REPORT_SCHEDULES: "/crm/reports/schedules",
  // PLC W16 Inc-3 — named distribution lists (SL `report_distribution`). Static,
  // so it outranks ":reportId" the same way (no descriptor id is
  // "distribution-lists"; no QUERYPARAMS, same hazard note).
  CRM_REPORT_DISTRIBUTION_LISTS: "/crm/reports/distribution-lists",
  // PLC W16 Inc-4 — report packages (SL `report_distribution`): the list and one
  // package's editor ("new" for a new one). "packages" is a static segment, so it
  // outranks ":reportId" the same way (no descriptor id is "packages"); the
  // `/crm/reports/` record-id subtree keeps the id from being read as an
  // instance id; no QUERYPARAMS, same hazard note.
  CRM_REPORT_PACKAGES: "/crm/reports/packages",
  CRM_REPORT_PACKAGE_DETAIL: "/crm/reports/packages/:packageId",
  CRM_REPORT_DETAIL: "/crm/reports/:reportId",
  // PLC W1: the units behind one report figure. Rendered by ReportPage (drill mode).
  CRM_REPORT_DRILL: "/crm/reports/:reportId/drill",
  /**
   * The ADVISOR surface of the same hub. A distinct path, not a query flag,
   * because the surface is derived FROM the route on both ends — the client
   * hook reads the pathname and the server reads its mount — so there is no
   * value a caller can set to be shown another surface's reports.
   */
  ADVISOR_REPORTS: "/advisor/reports",
  ADVISOR_REPORT_DETAIL: "/advisor/reports/:reportId",
  CRM_EVENTS: "/crm/events",
  CRM_EVENT_DETAIL: "/crm/events/:source/:eventId",
  CRM_COMMUNITY_EVENTS: "/crm/community-events",
  CRM_COMMUNITY_EVENT_NEW: "/crm/community-events/new",
  CRM_COMMUNITY_EVENT_DETAIL: "/crm/community-events/:eventId",
  CRM_HEALTH: "/crm/health",
  CRM_MESSENGER: "/crm/messenger",
  // The Setup hub (renamed from "Global Setup" — the container was named after
  // only one of its three scopes).
  CRM_SETUP: "/crm/setup",
  // LEGACY, bookmarks only. Mounted in appRoutes.ts on a permanent redirect to
  // CRM_SETUP that keeps the instance segment and the query string. Nothing
  // else in the app may point at this address.
  CRM_GLOBAL_SETUP: "/crm/global-setup",
  CRM_PACKS: "/crm/settings/packs",
  CRM_TERMINOLOGY: "/crm/settings/terminology",
  CRM_CUSTOM_FIELDS: "/crm/settings/custom-fields",
  CRM_LEAD_SOURCES: "/crm/settings/lead-sources",
  // PLC W8 Inc-5 — lead-source groups (senior-living `lead_source_taxonomy` feature).
  CRM_LEAD_SOURCE_GROUPS: "/crm/settings/lead-source-groups",
  // PLC Section 1 Inc-4 — saved community groups (senior-living `portfolio_overview`).
  CRM_COMMUNITY_GROUPS: "/crm/settings/community-groups",
  // PLC W12 Inc-4 — stand-up distribution lists (senior-living `standup_distribution`).
  CRM_STANDUP_LISTS: "/crm/settings/standup-lists",
  CRM_API_TOKENS: "/crm/settings/api-tokens",
  // Singular = the create/edit screen, mirroring the CRM_COMMUNITIES /
  // CRM_COMMUNITY_SETUP split. Keeping the editor off the plural path avoids
  // colliding with the list route's optional :instanceid segment.
  CRM_API_TOKEN_EDIT: "/crm/settings/api-token",
  CRM_WEBHOOKS: "/crm/settings/webhooks",
  // Singular editor path, same reasoning as CRM_API_TOKEN_EDIT: keeping it off
  // the plural path avoids colliding with the list route's optional
  // :instanceid segment.
  CRM_WEBHOOK_EDIT: "/crm/settings/webhook",
  CRM_CLOSE_REASONS: "/crm/settings/close-reasons",
  // PLC W7 Inc-3 — the managed competitor list the 'competitor' reasons pick from.
  CRM_COMPETITORS: "/crm/settings/competitors",
  CRM_MOTIVATORS: "/crm/settings/motivators",
  CRM_BARRIERS: "/crm/settings/barriers",
  // D1 (V190) — the CLOSED vocabulary of prospect-side actions a counselor can
  // ask a family to take. Kebab-case to match the API segment.
  CRM_COMMITMENT_TYPES: "/crm/settings/commitment-types",
  // PLC W13 Inc-3 — Discovery Coach settings (the follow-up invitation).
  CRM_DISCOVERY_COACHING: "/crm/settings/discovery-coaching",
  CRM_MOVE_OUT_REASONS: "/crm/settings/move-out-reasons",
  // PLC W9 Inc-2 — the managed concession type list (senior-living `concessions` feature).
  CRM_CONCESSION_TYPES: "/crm/settings/concession-types",
  CRM_MESSAGE_TEMPLATES: "/crm/settings/message-templates",
  CRM_COMMUNICATION_TEMPLATES: "/crm/settings/communication-templates",
  CRM_PROFILE: "/crm/profile",
  CRM_GOALS: "/crm/settings/goals",
  CRM_SLA_CONFIG: "/crm/settings/response-slas",
  // PLC W15 Inc-5 — the account default weekly business hours.
  CRM_BUSINESS_HOURS: "/crm/settings/business-hours",
  CRM_SCORING_CONFIG: "/crm/settings/lead-scoring",
  CRM_DASHBOARD_LAYOUTS: "/crm/settings/dashboard-layouts",
  CRM_ANNOUNCEMENTS: "/crm/settings/announcements",
  CRM_DATA_EXPORT: "/crm/settings/data-export",
  CRM_BI_FEED: "/crm/settings/bi-feed",
  // G18 — outbound delivery destinations (SFTP today) + the delivery log.
  CRM_DELIVERY_DESTINATIONS: "/crm/settings/delivery-destinations",
  CRM_DELIVERY_DESTINATION_EDIT: "/crm/settings/delivery-destination",
  CRM_AI_GOVERNANCE: "/crm/settings/ai-governance",
  CRM_ACCESS_LOG: "/crm/settings/access-log",
  // [FT-REHOME-RETENTION] (STATUS-audit-export.md §8) DISCHARGED — audit retention is
  // its own records-management surface, not a section of the AI Governance page.
  // The old address (/crm/settings/ai-governance?section=audit-retention) was
  // recorded there as "a v1 convenience, not the permanent home"; this is the
  // permanent home, and the old address forwards here (AiGovernancePage's legacy
  // wrapper).
  //
  // Named for the RECORDS it governs — matching its API (/crm/audit-retention)
  // rather than the page it used to be a guest on. Three of the four classes it
  // configures are not AI in any sense.
  CRM_AUDIT_RETENTION: "/crm/settings/audit-retention",
  // G9 §12 F8 item 1 — COMPLIANCE, deliberately a sibling of AI Governance and
  // not a section inside it: consent enforcement is statutory, not AI policy.
  CRM_CONSENT_ENFORCEMENT: "/crm/settings/consent-enforcement",
  CRM_AUTOMATIONS: "/crm/settings/automations",
  CRM_STAGES: "/crm/settings/stages",
  CRM_ACTIVITY_RESULTS: "/crm/settings/activity-results",
  CRM_ACTIVITY_TYPES: "/crm/settings/activity-types",
  CRM_CARE_TYPES: "/crm/settings/care-types",
  CRM_COMMUNITIES: "/crm/settings/communities",
  CRM_COMMUNITY_SETUP: "/crm/settings/community-setup",
  CRM_RELATIONSHIPS: "/crm/settings/relationships",
  CRM_CLINICAL_SYNC: "/crm/settings/clinical-sync",
  CRM_MARKETING_INTEGRATIONS: "/crm/settings/marketing-integrations",
  CRM_INTEGRATIONS: "/crm-integrations",
  FORMS: "/forms",
  FORM_BUILDER: "/forms/:id/edit",
  CAMPAIGNS: "/campaigns",
  CAMPAIGN_BUILDER: "/campaigns/:id/edit",
  CONTENT_HUB: "/content-hub",
  LANDING_PAGES: "/landing-pages",
  LANDING_PAGE_BUILDER: "/landing-pages/:id",
  INQUIRY_TYPES: "/inquiry-types",
  AB_TESTS: "/ab-tests",
  FLOOR_PLANS: "/floor-plans",
  TESTIMONIALS: "/testimonials",
  LEAD_MAGNETS: "/lead-magnets",
  TOUR_AVAILABILITY: "/tour-availability",
  SCHEDULED_TOURS: "/scheduled-tours",
  ALERT_BANNERS: "/alert-banners",
  VIDEOS: "/videos",
  FAQ: "/faq",
  STAFF_PROFILES: "/staff-profiles",
  SMS_ALERT_SETTINGS: "/sms-alert-settings",
  NOTIFICATION_PREFERENCES: "/notification-preferences",
  CONFIGURATIONS: "/settings/configurations",
  // H3 Inc-2: the Advisor-side door to the close-reason catalog. Distinct path
  // from CRM_CLOSE_REASONS ("/crm/settings/close-reasons"), same editor and same
  // API — Element Care buys skyAdvisor only, so a /crm-only surface is undelivered.
  // R6 — the Advisor Setup hub. Tiles live in CODE, so a new configuration
  // surface never again needs a per-tenant platform_config patch to be reachable.
  SETTINGS_SETUP: "/settings/setup",
  SETTINGS_CLOSE_REASONS: "/settings/close-reasons",
  // PLC W7 Inc-3 — the Advisor-side door to the managed competitor list (same
  // editor + API as CRM_COMPETITORS; gated exactly like Close Reasons).
  SETTINGS_COMPETITORS: "/settings/competitors",
  // PACE (`pipeline_funnel`) — the Advisor-side, rename-only stage settings page.
  SETTINGS_STAGES: "/settings/stages",
  // vertical-lead-profile — Skypoint-admin-only per-tenant prompt / temperature overrides.
  SETTINGS_LEAD_PROFILE: "/settings/lead-profile",
  CALL_MANAGEMENT: "/call-management",
  ASSESSMENTS: "/assessments",
  ASSESSMENT_BUILDER: "/assessments/:id/edit",
  PUBLIC_ASSESSMENT: "/assessment/:instanceId/:token",
  INSTRUMENTATIONKEYREACT: "c433df71-1d5b-4a1b-b68a-b0b95f53cd93",
  SIGNUP: "/signup",
} as const;

export const DocumentLink: Record<string, string> = {
  ":instanceid?": "/overview",
  "/": "/home",
  "/apps": "/overview",
  "/settings/session": "/tenant",
  "/security": "/security",
  "/privacycenter": "/privacycenter",
  "/editprivacycenter": "/editprivacycenter",
  "/datasubjectrequests": "/datasubjectrequest",
  "/datasubjectrequestcreate": "/datasubjectrequest",
  "/templates": "/privacytemplates",
  "/edittemplate": "/privacytemplates",
  "/reports": "/privacyreports",
  "/reportconsent": "/reports",
  "/errorpage": "/errorpage",
  "/auth/callback": "/auth/callback",
  "/skypointlogin": "/login",
  "/skypointsignup": "/signup",
  "/tabledata": "/tabledata",
  "/overlapdetails": "/overlapdetails",
  "/differentiatordetails": "/audiences",
  "/settings/instances": "/instance",
  "/settings/instanceDetails": "/instance",
  "/settings/instanceHistory": "/instance",
  "/settings/instanceBackup": "/instance",
  "/schedule": "/schedule",
  "/settings/tenants": "/tenant",
  "/transformations": "/transformations",
  "/inbox": "/inbox",
};

export const PREVIEWFIELDS = {
  date: new Date(Date.UTC(2012, 1, 20, 3, 0, 0)),
};
export const PREVIEWNUMBER = 456789.12;
export const PREVIEWPERCENTAGE = 12.8;

export const TIMEOUT_LOW = 10000;
export const TIMEOUT_MEDIUM = 20000;

export const ADD_NOTIFICATION = "ADD_NOTIFICATION";
export const REMOVE_NOTIFICATION = "REMOVE_NOTIFICATION";
export const RESET = "RESET";

export const SUCCESS_MESSAGE = "successMessage";
export const ERROR_MESSAGE = "errorMessage";
export const SUCCESS_MESSAGE_BAR = "successMessageBar";
export const ERROR_MESSAGE_BAR = "errorMessageBar";
export const SUCCESS_MESSAGE_DASHBOARD = "successMessageDashboard";
export const ERROR_MESSAGE_DASHBOARD = "errorMessageDashboard";
export const WARNING_MESSAGE_DASHBOARD = "warningMessageDashboard";

export const BANKACCOUNTHOLDER = {
  INDIVIDUAL: "Individual",
  COMPANY: "Company",
} as const;

export const CONSTANTS = {
  tableLowerCase: "table",
  tableUpperCase: "Table",
  tablesLowerCase: "tables",
  tablesUpperCase: "Tables",
  database: "Database",
  databases: "Databases",
  tableName: "Table name",
} as const;

export const FILTER_OPTIONS = [
  "Contains",
  "Does not contain",
  "Start with",
  "Ends with",
  "Is null",
  "Is not null",
] as const;

export const INSTANCE_HISTORY_ACTION_TYPES = {
  Create: "Create",
  Edit: "Edit",
} as const;

export const INSTANCE_HISTORY_STATUS_TYPES = {
  Success: "Success",
  Failed: "Failed",
} as const;

export const COMMON_NOTIFICATION_MESSAGES = {
  errorMessage: "Something went wrong",
} as const;
